import { render, staticRenderFns } from "./MonsterManual.vue?vue&type=template&id=f6fd4d52"
import script from "./MonsterManual.vue?vue&type=script&lang=js"
export * from "./MonsterManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6fd4d52')) {
      api.createRecord('f6fd4d52', component.options)
    } else {
      api.reload('f6fd4d52', component.options)
    }
    module.hot.accept("./MonsterManual.vue?vue&type=template&id=f6fd4d52", function () {
      api.rerender('f6fd4d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/monster/MonsterManual.vue"
export default component.exports